require.register("search/app", function(exports, require, module){
  $0
  
});

